import { ApartmentOutlined, ApiOutlined, CreditCardOutlined, HeartOutlined, NotificationOutlined, UserOutlined } from "@ant-design/icons"

type HeaderMenu = {
    title: string,
    icon: any,
    link: string,
    accessRoles: 'STUDENT' | 'TEACHER' | 'ALL',
    subMenu?: HeaderMenu[]
}
export const headerMenu: HeaderMenu[] = [
    {
        title: 'Home',
        icon: null,
        link: '',
        accessRoles: 'ALL'
    },
    {
        title: "Classes",
        icon: null,
        link: '/class',
        accessRoles: 'TEACHER'
    },
    {
        title: 'Interactive Video',
        icon: null,
        link: '/interactive-video',
        accessRoles: 'STUDENT'
    },
    {
        title: 'Analyse',
        icon: null,
        link: '/analyse',
        accessRoles: 'TEACHER'
    }

]

export const announcementBanner = [{
    show: false,
    title: "This is an announcment",
    action: "http://zoomUrl",
    location: ['home', 'class', 'setting', "session"],
    audience: ["STUDENT", "TEACHER"]
}]

export const enable_prepare_class = true
export const enable_setting_class_students = true
export const enable_setting_class_configure = true
export const OTP_RESEND_SECONDS = 30;
export const DefaultTileCardTextColor = "#3182ce"
export const DefaultTileCardTextColorClass = 'text-blue-600'

//need alternate host URL to avoid shared local storage.
// export const alternateHostUrl = "https://762e-2401-4900-1cb9-7c67-b1fe-b9c3-7ee2-4f42.in.ngrok.io"
export const alternateHostUrl = "https://demo.vidya.us"
export const dummyStudentEmail = "student@vidyatest.us"
export const dumyStudentPassword = "1234"
export const dummyStudentName = "Sheldon Cooper"

export const Subjects = ["Abacus", "Accountancy", "Acting", "Agriculture", "Agronomy", "Algebra", "All Subjects", "Analog Electronics", "Analytical chemistry", "Analytics", "Anatomy", "Ancient History", "Android", "Animal Husbandry", "Animal physiology", "Anthropology", "Applied mathematics", "Applied Mechanics", "Applied physics", "Aptitude", "Arabic", "Arithematic", "Art", "Art & Craft", "Art & Culture", "Artificial Intelligence", "Assamese", "Astrology", "Astronomy", "Audit", "Autocad", "Automobile", "Ayurveda", "Bangla", "Banking", "Bengali", "Bharatnatyam", "Bible", "Biochemistry", "Biography", "Biology", "Biotechnology", "Botany", "Building construction", "Building materials", "Bureau of Energy Efficiency (BEE)", "Business", "Business Communication", "Business Economics", "Business Environment", "Business Law", "Business Management", "Business relationship management (BRM)", "Business statistics", "Business Study", "C", "C++", "Calculus", "Campany Law", "Chemistry", "Chess", "Child Development", "Child Health Nursing", "Child poems", "Child Psychology", "Circuit theory", "Civics", "Cloud Computing", "Coding", "Commerce", "Communication", "Communication skills", "Community Health nursing", "Competitive", "Complex analysis", "Computer", "Computer Application", "Computer Fundamental", "Computer Graphics", "Computer Hardware", "Computer network", "Computer Science", "Constitution", "Constitution of india", "Constitutional Law", "Control system", "Conversation", "Cooking", "Corporate Accounting", "Cost Accounting", "Costing", "Creative School", "Crop production", "Current Affairs", "Cyber Security", "Dance", "Data science", "Data Security Standard (DSS)", "Data Structure", "Database managment system (DBMS)", "DE", "Defence", "Design", "Design of machine elements", "Digital Electronics", "Digital Marketing", "Diploma in Advance Accounting (DAA)", "Direct Tax", "DME", "Domestic Data Entry Operator (DDEO)", "Drama", "Drawing and painting", "DSA", "Ecology", "Economics", "Economy", "Electrical", "Electrical Engineering (EE)", "Electrical Machine", "Electrical theory", "Electrician", "Electrician Theory", "Electronic", "Electronic devices and circuits (EDC)", "Emergency Medicine (EM)", "Enbedded system", "Energy Conservation", "Engineering", "Engineering Drawing", "Engineering Graphics", "Engineering maths", "Engineering Mechanics", "Engineering physics", "English", "English Grammar", "English Language", "English Literature", "English Shorthand", "English Speaking", "Enterprise information management (EIM)", "Entomology", "Entrepreneurship", "Environment", "Environmental Studies (EVS)", "Ethics", "Evidence", "Fashion designing", "Finance", "Financial Accounting", "Financial Management", "Fine Arts", "Fitness", "Fitter theory", "Fluid Mechanics", "Food production", "French", "Fun", "Fundamental", "General Awareness", "General Competition", "General Discussion", "General Knowledge", "General Science", "General Studies", "Genetics", "Geography", "Geology", "Geometry", "Geotechnical Engineering", "German", "Grammar", "Grpahic design", "GST", "Guitar", "Gujrati", "Hacking", "Handwriting", "Health", "Healthcare", "Heat Transfer", "Highway Engineering", "Hindi", "Hindi Grammar", "Hindi Language", "Hindi Literature", "Hindi Shorthand", "Hindu law", "History", "Home Science", "Horticulture", "HR", "HTML", "Humanities", "Hydraulics", "IELTS", "Immunology", "Income Tax", "Indian Constitution", "Indian Geography", "Indian Penal Code (IPC)", "Indirect Tax", "Informatics Practices", "Information and Communication Technology (ICT)", "Information Protocol", "Information Technology", "Inorganic Chemistry", "Insurance", "International Relations", "Internet Of Things (IOT)", "Irrigation", "Islamic", "Islamic studies", "IT", "Japanese", "Java", "Javascript", "Journalism", "Juriprudence", "Jyotishi", "Kannada", "Karate", "Kashmiri", "Kathak", "Keyboard", "Laboratory", "Language", "Law", "Law of contract", "Legal studies", "Library and Information Science (LIS)", "Library science", "LIC", "Life Science", "Life Skills", "Linux", "Literature", "Machine Design", "Machine Drawing", "Machine Learning", "Macro economics", "Malayalam", "malyalam", "Management", "Management Accounting", "Managerial Economics", "Manipuri", "Marathi", "Marketing", "Marketing Management", "Mass Communication", "Material Science", "Maths", "Mathematics", "Matlab", "MBBS", "Mechanical", "Mechanical Engineering", "Mechanics", "Mechatronics", "Medical", "Medicinal Chemistry", "Medicine", "Meditation", "Meeting", "Mental Ability", "Mental health nursing", "Micro economics", "Microbiology", "Microcontroller", "Microprocessor", "Microsoft Excel", "Microsoft Office", "Microsoft Word", "Mining", "Moral education", "Moral Science", "Motivation", "Motivational", "MS Excel", "Music", "Nepali", "Network Analysis", "Network Maketing", "Network theory", "Networking", "NTPC", "Number System", "Numerical analysis", "Nursing", "Nutrition", "Obstetrics and gynaecology", "Odia", "Operating structure", "Operating System", "Operation Research", "Organic Chemistry", "Painting", "Pathology", "Pedagogy", "Pediatrics", "Personality Development", "Pharmaceutical Analysis", "Pharmaceutics", "Pharmacognosy", "Pharmacology", "Pharmacy", "Philosophy", "Phonics", "Photography", "Photoshop", "PHP", "Physical Chemistry", "Physical Education", "Physical Science", "Physics", "Physiology", "Piano", "Plant Pathalogy", "Poetry", "Political Science", "Power electronics", "Power system", "Priniciples of Management", "Prinicples of Marketing", "Programming", "Psychology", "Physical training", "Public Administration", "Public Speaking", "Punjabi", "Pysiotheraphy", "Python", "Quantitative Aptitude", "Quantum Mechanics", "Quran", "Relationa Database managment system (RDBMS)", "Reasoning", "Research", "Research methodology", "Retail mangement", "Rhymes", "Robotics", "Sales", "Sanskrit", "Science", "Share market", "Shorthand", "Signals and Systems", "Singing", "Skill developement", "Social Science", "Sociology", "Soft skills", "Software enginneering", "Software Testing", "Soil Mechanics", "Soil Science", "Spanish", "Spoken English", "Sports", "SQL", "Statistics", "Stenography", "Stock Market", "Strategic management", "Strength of material", "Strength of Materials", "Structual Design", "Surgery", "Surgical Nursing", "Survey", "Tabla", "Tajweed", "Tally", "Tamil", "Tax", "Teaching", "Technical", "Technical Analysis", "Telegu", "Theory", "Theory of machine", "Thermal engineering", "Thermodynamics", "Tibetan", "Trade Theory", "Trading", "Train the Trainer (TTT)", "Trigonometry", "UEEE", "Urdu", "Value Education", "Vedic Maths", "Very large scale integration (VLSI)", "Vocabulary", "Vocal", "Web Design", "Web developement", "Web Technology", "Welder", "Wireless communication system (WCS)", "Wireman", "Wordpress", "Workshop calculation", "Writing", "Yoga", "Youtube", "Zoology", "OTHERS"];

export const IPLOOKUPURL = 'https://extreme-ip-lookup.com/json/?key=lCTvtiNRFyeshVHJJB9E'
export const DetectLanguageURL = "https://ws.detectlanguage.com/0.2/detect"
export const ZOOM_CLIENT_ID = 'hBItTJhjRa6GPLnWDPQXQ'
export const ZOOM_APP_OAUTH_STATE_SECRET = "85de492b9b26ffc7edbfa1702bdd2519"
export const NEW_USER_GOOGLE_URL = "https://script.google.com/macros/s/AKfycby_hHwMLrGi3NJnRrFJHaJDotaYEMaohA-NHp9BOfrPT2bZnejrAlCTov4bS-KzYI87CQ/exec"

export const isRunningAsZoomApp = window.navigator.userAgent.includes('ZoomApps');
// export const isZoomApp = window.navigator.userAgent.includes('Chrome');
export const isRunningAsTeamsApp = false;
export const isEmbed = ['embed.vidya.us', 'dev-embed.vidya.us'].includes(window.location.host)
export const persistToken = true;
// export const persistToken = !isRunningAsZoomApp;
export const isGuestModeSupported = true;
export const GUESTOTP = "1234";
export const GUESTDOMAIN = "vidyatest.us"
export const GuestEmailPlaceholder = 'Guest'


export const notionRenderBaseUrl = "https://notion-api.splitbee.io/v1/page/"
export const notionSopPath = "SOP-bfaf7af2d2f0433cb1fc17b135ea6927"

export const payment_link_personal_monthly = 'https://buy.stripe.com/8wMg2NdocekN8qk145'

export const GOOGLE_CLIENT_ID = '468450185582-7nukfc72fgjjf91blft52t6vljbf5lj9.apps.googleusercontent.com'

export const ENABLE_GOOGLE_AUTH_IN_ZOOM = false;
export const ENABLE_GOOGLE_AUTH_OUTSIDE_ZOOM = false;

export const vidyaDownloadBaseUrl = "download.vidya.us"
export const googleStorageApisURL = "storage.googleapis.com"

export const sessionTheme: 'dark' | 'light' = 'dark';

export const firebaseProdConfig = {
    apiKey: "AIzaSyALJbSnyNGZ0Tpworde5SG_VZRt9siAVQc",
    authDomain: "boxwood-coil-362510.firebaseapp.com",
    projectId: "boxwood-coil-362510",
    storageBucket: "boxwood-coil-362510.appspot.com",
    messagingSenderId: "789448815032",
    appId: "1:789448815032:web:8833e3f1c4d36e2afbdf4d",
    measurementId: "G-NEH7GNSN2Y"
}

export const firebaseDevConfig = {
    apiKey: "AIzaSyA_RPwefYlq1ZSOZaMD6iR7TnmtSxtQq_Y",
    authDomain: "vidya-prod-f2207.firebaseapp.com",
    projectId: "vidya-prod-f2207",
    storageBucket: "vidya-prod-f2207.appspot.com",
    messagingSenderId: "65820137593",
    appId: "1:65820137593:web:b3247a1124a58a689b5ca8",
    measurementId: "G-1RKY9G44HM"
};


export const FAQs = [
    {
        q: "How safe is my data?",
        a: "At Vidya, we take the security of your data very seriously. All your data is encrypted and stored securely, and we use the latest technology to protect it."
    },
    {
        q: "Can I integrate Vidya into my own app?",
        a: "Yes, you can integrate Vidya into your own app. For more information, please contact our team."
    },
    {
        q: "Can I change my subscription?",
        a: "Yes, you can change your subscription at any time."
    },
    {
        q: "Can I cancel my subscription?",
        a: "Yes, you can cancel your subscription at any time."
    },
    {
        q: "If I cancel my subscription, will I be eligible for a refund?",
        a: "If you choose to cancel your subscription, you will not be eligible for a refund."
    },
    {
        q: "What is the fee for my subscription?",
        a: "You will be charged a monthly fee for your subscription. The amount will be displayed on the billing page when you subscribe."
    }
]

export const sampleStudents = [
    { "email": "jennifer.carroll@vidya.us", "role": "STUDENT", "full_name": "Jennifer Carroll", "first_name": "Jennifer", "last_name": "Carroll", "username": "jennifer.carroll" },
    { "email": "benjamin.lopez@vidya.us", "role": "STUDENT", "full_name": "Benjamin Lopez", "first_name": "Benjamin", "last_name": "Lopez", "username": "benjamin.lopez" },
    { "email": "james.lynch@vidya.us", "role": "STUDENT", "full_name": "James Lynch", "first_name": "James", "last_name": "Lynch", "username": "james.lynch" },
    { "email": "mark.clark@vidya.us", "role": "STUDENT", "full_name": "Mark Clark", "first_name": "Mark", "last_name": "Clark", "username": "mark.clark" },
    { "email": "dana.johnson@vidya.us", "role": "STUDENT", "full_name": "Dana Johnson", "first_name": "Dana", "last_name": "Johnson", "username": "dana.johnson" },
    { "email": "jillian.arnold@vidya.us", "role": "STUDENT", "full_name": "Jillian Arnold", "first_name": "Jillian", "last_name": "Arnold", "username": "jillian.arnold" },
    { "email": "melissa.harris@vidya.us", "role": "STUDENT", "full_name": "Melissa Harris", "first_name": "Melissa", "last_name": "Harris", "username": "melissa.harris" },
    { "email": "kevin.tucker@vidya.us", "role": "STUDENT", "full_name": "Kevin Tucker", "first_name": "Kevin", "last_name": "Tucker", "username": "kevin.tucker" },
    { "email": "todd.lawson@vidya.us", "role": "STUDENT", "full_name": "Todd Lawson", "first_name": "Todd", "last_name": "Lawson", "username": "todd.lawson" },
    { "email": "timothy.walker@vidya.us", "role": "STUDENT", "full_name": "Timothy Walker", "first_name": "Timothy", "last_name": "Walker", "username": "timothy.walker" },
    { "email": "susan.kelley@vidya.us", "role": "STUDENT", "full_name": "Susan Kelley", "first_name": "Susan", "last_name": "Kelley", "username": "susan.kelley" },
    { "email": "amy.moss@vidya.us", "role": "STUDENT", "full_name": "Amy Moss", "first_name": "Amy", "last_name": "Moss", "username": "amy.moss" },
    { "email": "paige.cruz@vidya.us", "role": "STUDENT", "full_name": "Paige Cruz", "first_name": "Paige", "last_name": "Cruz", "username": "paige.cruz" },
    { "email": "tracey.phillips@vidya.us", "role": "STUDENT", "full_name": "Tracey Phillips", "first_name": "Tracey", "last_name": "Phillips", "username": "tracey.phillips" },
    { "email": "kenneth.davis@vidya.us", "role": "STUDENT", "full_name": "Kenneth Davis", "first_name": "Kenneth", "last_name": "Davis", "username": "kenneth.davis" },
    { "email": "wayne.miller@vidya.us", "role": "STUDENT", "full_name": "Wayne Miller", "first_name": "Wayne", "last_name": "Miller", "username": "wayne.miller" },
    { "email": "anthony.price@vidya.us", "role": "STUDENT", "full_name": "Anthony Price", "first_name": "Anthony", "last_name": "Price", "username": "anthony.price" },
    { "email": "brian.cantu@vidya.us", "role": "STUDENT", "full_name": "Brian Cantu", "first_name": "Brian", "last_name": "Cantu", "username": "brian.cantu" },
    { "email": "christina.robinson@vidya.us", "role": "STUDENT", "full_name": "Christina Robinson", "first_name": "Christina", "last_name": "Robinson", "username": "christina.robinson" },
    { "email": "ronnie.myers@vidya.us", "role": "STUDENT", "full_name": "Ronnie Myers", "first_name": "Ronnie", "last_name": "Myers", "username": "ronnie.myers" }
]

export const country_codes = [
    {
        "name": "Afghanistan",
        "dial_code": "+93",
        "code": "AF"
    },
    {
        "name": "Aland Islands",
        "dial_code": "+358",
        "code": "AX"
    },
    {
        "name": "Albania",
        "dial_code": "+355",
        "code": "AL"
    },
    {
        "name": "Algeria",
        "dial_code": "+213",
        "code": "DZ"
    },
    {
        "name": "AmericanSamoa",
        "dial_code": "+1684",
        "code": "AS"
    },
    {
        "name": "Andorra",
        "dial_code": "+376",
        "code": "AD"
    },
    {
        "name": "Angola",
        "dial_code": "+244",
        "code": "AO"
    },
    {
        "name": "Anguilla",
        "dial_code": "+1264",
        "code": "AI"
    },
    {
        "name": "Antarctica",
        "dial_code": "+672",
        "code": "AQ"
    },
    {
        "name": "Antigua and Barbuda",
        "dial_code": "+1268",
        "code": "AG"
    },
    {
        "name": "Argentina",
        "dial_code": "+54",
        "code": "AR"
    },
    {
        "name": "Armenia",
        "dial_code": "+374",
        "code": "AM"
    },
    {
        "name": "Aruba",
        "dial_code": "+297",
        "code": "AW"
    },
    {
        "name": "Australia",
        "dial_code": "+61",
        "code": "AU"
    },
    {
        "name": "Austria",
        "dial_code": "+43",
        "code": "AT"
    },
    {
        "name": "Azerbaijan",
        "dial_code": "+994",
        "code": "AZ"
    },
    {
        "name": "Bahamas",
        "dial_code": "+1242",
        "code": "BS"
    },
    {
        "name": "Bahrain",
        "dial_code": "+973",
        "code": "BH"
    },
    {
        "name": "Bangladesh",
        "dial_code": "+880",
        "code": "BD"
    },
    {
        "name": "Barbados",
        "dial_code": "+1246",
        "code": "BB"
    },
    {
        "name": "Belarus",
        "dial_code": "+375",
        "code": "BY"
    },
    {
        "name": "Belgium",
        "dial_code": "+32",
        "code": "BE"
    },
    {
        "name": "Belize",
        "dial_code": "+501",
        "code": "BZ"
    },
    {
        "name": "Benin",
        "dial_code": "+229",
        "code": "BJ"
    },
    {
        "name": "Bermuda",
        "dial_code": "+1441",
        "code": "BM"
    },
    {
        "name": "Bhutan",
        "dial_code": "+975",
        "code": "BT"
    },
    {
        "name": "Bolivia, Plurinational State of",
        "dial_code": "+591",
        "code": "BO"
    },
    {
        "name": "Bosnia and Herzegovina",
        "dial_code": "+387",
        "code": "BA"
    },
    {
        "name": "Botswana",
        "dial_code": "+267",
        "code": "BW"
    },
    {
        "name": "Brazil",
        "dial_code": "+55",
        "code": "BR"
    },
    {
        "name": "British Indian Ocean Territory",
        "dial_code": "+246",
        "code": "IO"
    },
    {
        "name": "Brunei Darussalam",
        "dial_code": "+673",
        "code": "BN"
    },
    {
        "name": "Bulgaria",
        "dial_code": "+359",
        "code": "BG"
    },
    {
        "name": "Burkina Faso",
        "dial_code": "+226",
        "code": "BF"
    },
    {
        "name": "Burundi",
        "dial_code": "+257",
        "code": "BI"
    },
    {
        "name": "Cambodia",
        "dial_code": "+855",
        "code": "KH"
    },
    {
        "name": "Cameroon",
        "dial_code": "+237",
        "code": "CM"
    },
    {
        "name": "Canada",
        "dial_code": "+1",
        "code": "CA"
    },
    {
        "name": "Cape Verde",
        "dial_code": "+238",
        "code": "CV"
    },
    {
        "name": "Cayman Islands",
        "dial_code": "+ 345",
        "code": "KY"
    },
    {
        "name": "Central African Republic",
        "dial_code": "+236",
        "code": "CF"
    },
    {
        "name": "Chad",
        "dial_code": "+235",
        "code": "TD"
    },
    {
        "name": "Chile",
        "dial_code": "+56",
        "code": "CL"
    },
    {
        "name": "China",
        "dial_code": "+86",
        "code": "CN"
    },
    {
        "name": "Christmas Island",
        "dial_code": "+61",
        "code": "CX"
    },
    {
        "name": "Cocos (Keeling) Islands",
        "dial_code": "+61",
        "code": "CC"
    },
    {
        "name": "Colombia",
        "dial_code": "+57",
        "code": "CO"
    },
    {
        "name": "Comoros",
        "dial_code": "+269",
        "code": "KM"
    },
    {
        "name": "Congo",
        "dial_code": "+242",
        "code": "CG"
    },
    {
        "name": "Congo, The Democratic Republic of the Congo",
        "dial_code": "+243",
        "code": "CD"
    },
    {
        "name": "Cook Islands",
        "dial_code": "+682",
        "code": "CK"
    },
    {
        "name": "Costa Rica",
        "dial_code": "+506",
        "code": "CR"
    },
    {
        "name": "Cote d'Ivoire",
        "dial_code": "+225",
        "code": "CI"
    },
    {
        "name": "Croatia",
        "dial_code": "+385",
        "code": "HR"
    },
    {
        "name": "Cuba",
        "dial_code": "+53",
        "code": "CU"
    },
    {
        "name": "Cyprus",
        "dial_code": "+357",
        "code": "CY"
    },
    {
        "name": "Czech Republic",
        "dial_code": "+420",
        "code": "CZ"
    },
    {
        "name": "Denmark",
        "dial_code": "+45",
        "code": "DK"
    },
    {
        "name": "Djibouti",
        "dial_code": "+253",
        "code": "DJ"
    },
    {
        "name": "Dominica",
        "dial_code": "+1767",
        "code": "DM"
    },
    {
        "name": "Dominican Republic",
        "dial_code": "+1849",
        "code": "DO"
    },
    {
        "name": "Ecuador",
        "dial_code": "+593",
        "code": "EC"
    },
    {
        "name": "Egypt",
        "dial_code": "+20",
        "code": "EG"
    },
    {
        "name": "El Salvador",
        "dial_code": "+503",
        "code": "SV"
    },
    {
        "name": "Equatorial Guinea",
        "dial_code": "+240",
        "code": "GQ"
    },
    {
        "name": "Eritrea",
        "dial_code": "+291",
        "code": "ER"
    },
    {
        "name": "Estonia",
        "dial_code": "+372",
        "code": "EE"
    },
    {
        "name": "Ethiopia",
        "dial_code": "+251",
        "code": "ET"
    },
    {
        "name": "Falkland Islands (Malvinas)",
        "dial_code": "+500",
        "code": "FK"
    },
    {
        "name": "Faroe Islands",
        "dial_code": "+298",
        "code": "FO"
    },
    {
        "name": "Fiji",
        "dial_code": "+679",
        "code": "FJ"
    },
    {
        "name": "Finland",
        "dial_code": "+358",
        "code": "FI"
    },
    {
        "name": "France",
        "dial_code": "+33",
        "code": "FR"
    },
    {
        "name": "French Guiana",
        "dial_code": "+594",
        "code": "GF"
    },
    {
        "name": "French Polynesia",
        "dial_code": "+689",
        "code": "PF"
    },
    {
        "name": "Gabon",
        "dial_code": "+241",
        "code": "GA"
    },
    {
        "name": "Gambia",
        "dial_code": "+220",
        "code": "GM"
    },
    {
        "name": "Georgia",
        "dial_code": "+995",
        "code": "GE"
    },
    {
        "name": "Germany",
        "dial_code": "+49",
        "code": "DE"
    },
    {
        "name": "Ghana",
        "dial_code": "+233",
        "code": "GH"
    },
    {
        "name": "Gibraltar",
        "dial_code": "+350",
        "code": "GI"
    },
    {
        "name": "Greece",
        "dial_code": "+30",
        "code": "GR"
    },
    {
        "name": "Greenland",
        "dial_code": "+299",
        "code": "GL"
    },
    {
        "name": "Grenada",
        "dial_code": "+1473",
        "code": "GD"
    },
    {
        "name": "Guadeloupe",
        "dial_code": "+590",
        "code": "GP"
    },
    {
        "name": "Guam",
        "dial_code": "+1671",
        "code": "GU"
    },
    {
        "name": "Guatemala",
        "dial_code": "+502",
        "code": "GT"
    },
    {
        "name": "Guernsey",
        "dial_code": "+44",
        "code": "GG"
    },
    {
        "name": "Guinea",
        "dial_code": "+224",
        "code": "GN"
    },
    {
        "name": "Guinea-Bissau",
        "dial_code": "+245",
        "code": "GW"
    },
    {
        "name": "Guyana",
        "dial_code": "+595",
        "code": "GY"
    },
    {
        "name": "Haiti",
        "dial_code": "+509",
        "code": "HT"
    },
    {
        "name": "Holy See (Vatican City State)",
        "dial_code": "+379",
        "code": "VA"
    },
    {
        "name": "Honduras",
        "dial_code": "+504",
        "code": "HN"
    },
    {
        "name": "Hong Kong",
        "dial_code": "+852",
        "code": "HK"
    },
    {
        "name": "Hungary",
        "dial_code": "+36",
        "code": "HU"
    },
    {
        "name": "Iceland",
        "dial_code": "+354",
        "code": "IS"
    },
    {
        "name": "India",
        "dial_code": "+91",
        "code": "IN"
    },
    {
        "name": "Indonesia",
        "dial_code": "+62",
        "code": "ID"
    },
    {
        "name": "Iran, Islamic Republic of Persian Gulf",
        "dial_code": "+98",
        "code": "IR"
    },
    {
        "name": "Iraq",
        "dial_code": "+964",
        "code": "IQ"
    },
    {
        "name": "Ireland",
        "dial_code": "+353",
        "code": "IE"
    },
    {
        "name": "Isle of Man",
        "dial_code": "+44",
        "code": "IM"
    },
    {
        "name": "Israel",
        "dial_code": "+972",
        "code": "IL"
    },
    {
        "name": "Italy",
        "dial_code": "+39",
        "code": "IT"
    },
    {
        "name": "Jamaica",
        "dial_code": "+1876",
        "code": "JM"
    },
    {
        "name": "Japan",
        "dial_code": "+81",
        "code": "JP"
    },
    {
        "name": "Jersey",
        "dial_code": "+44",
        "code": "JE"
    },
    {
        "name": "Jordan",
        "dial_code": "+962",
        "code": "JO"
    },
    {
        "name": "Kazakhstan",
        "dial_code": "+77",
        "code": "KZ"
    },
    {
        "name": "Kenya",
        "dial_code": "+254",
        "code": "KE"
    },
    {
        "name": "Kiribati",
        "dial_code": "+686",
        "code": "KI"
    },
    {
        "name": "Korea, Democratic People's Republic of Korea",
        "dial_code": "+850",
        "code": "KP"
    },
    {
        "name": "Korea, Republic of South Korea",
        "dial_code": "+82",
        "code": "KR"
    },
    {
        "name": "Kuwait",
        "dial_code": "+965",
        "code": "KW"
    },
    {
        "name": "Kyrgyzstan",
        "dial_code": "+996",
        "code": "KG"
    },
    {
        "name": "Laos",
        "dial_code": "+856",
        "code": "LA"
    },
    {
        "name": "Latvia",
        "dial_code": "+371",
        "code": "LV"
    },
    {
        "name": "Lebanon",
        "dial_code": "+961",
        "code": "LB"
    },
    {
        "name": "Lesotho",
        "dial_code": "+266",
        "code": "LS"
    },
    {
        "name": "Liberia",
        "dial_code": "+231",
        "code": "LR"
    },
    {
        "name": "Libyan Arab Jamahiriya",
        "dial_code": "+218",
        "code": "LY"
    },
    {
        "name": "Liechtenstein",
        "dial_code": "+423",
        "code": "LI"
    },
    {
        "name": "Lithuania",
        "dial_code": "+370",
        "code": "LT"
    },
    {
        "name": "Luxembourg",
        "dial_code": "+352",
        "code": "LU"
    },
    {
        "name": "Macao",
        "dial_code": "+853",
        "code": "MO"
    },
    {
        "name": "Macedonia",
        "dial_code": "+389",
        "code": "MK"
    },
    {
        "name": "Madagascar",
        "dial_code": "+261",
        "code": "MG"
    },
    {
        "name": "Malawi",
        "dial_code": "+265",
        "code": "MW"
    },
    {
        "name": "Malaysia",
        "dial_code": "+60",
        "code": "MY"
    },
    {
        "name": "Maldives",
        "dial_code": "+960",
        "code": "MV"
    },
    {
        "name": "Mali",
        "dial_code": "+223",
        "code": "ML"
    },
    {
        "name": "Malta",
        "dial_code": "+356",
        "code": "MT"
    },
    {
        "name": "Marshall Islands",
        "dial_code": "+692",
        "code": "MH"
    },
    {
        "name": "Martinique",
        "dial_code": "+596",
        "code": "MQ"
    },
    {
        "name": "Mauritania",
        "dial_code": "+222",
        "code": "MR"
    },
    {
        "name": "Mauritius",
        "dial_code": "+230",
        "code": "MU"
    },
    {
        "name": "Mayotte",
        "dial_code": "+262",
        "code": "YT"
    },
    {
        "name": "Mexico",
        "dial_code": "+52",
        "code": "MX"
    },
    {
        "name": "Micronesia, Federated States of Micronesia",
        "dial_code": "+691",
        "code": "FM"
    },
    {
        "name": "Moldova",
        "dial_code": "+373",
        "code": "MD"
    },
    {
        "name": "Monaco",
        "dial_code": "+377",
        "code": "MC"
    },
    {
        "name": "Mongolia",
        "dial_code": "+976",
        "code": "MN"
    },
    {
        "name": "Montenegro",
        "dial_code": "+382",
        "code": "ME"
    },
    {
        "name": "Montserrat",
        "dial_code": "+1664",
        "code": "MS"
    },
    {
        "name": "Morocco",
        "dial_code": "+212",
        "code": "MA"
    },
    {
        "name": "Mozambique",
        "dial_code": "+258",
        "code": "MZ"
    },
    {
        "name": "Myanmar",
        "dial_code": "+95",
        "code": "MM"
    },
    {
        "name": "Namibia",
        "dial_code": "+264",
        "code": "NA"
    },
    {
        "name": "Nauru",
        "dial_code": "+674",
        "code": "NR"
    },
    {
        "name": "Nepal",
        "dial_code": "+977",
        "code": "NP"
    },
    {
        "name": "Netherlands",
        "dial_code": "+31",
        "code": "NL"
    },
    {
        "name": "Netherlands Antilles",
        "dial_code": "+599",
        "code": "AN"
    },
    {
        "name": "New Caledonia",
        "dial_code": "+687",
        "code": "NC"
    },
    {
        "name": "New Zealand",
        "dial_code": "+64",
        "code": "NZ"
    },
    {
        "name": "Nicaragua",
        "dial_code": "+505",
        "code": "NI"
    },
    {
        "name": "Niger",
        "dial_code": "+227",
        "code": "NE"
    },
    {
        "name": "Nigeria",
        "dial_code": "+234",
        "code": "NG"
    },
    {
        "name": "Niue",
        "dial_code": "+683",
        "code": "NU"
    },
    {
        "name": "Norfolk Island",
        "dial_code": "+672",
        "code": "NF"
    },
    {
        "name": "Northern Mariana Islands",
        "dial_code": "+1670",
        "code": "MP"
    },
    {
        "name": "Norway",
        "dial_code": "+47",
        "code": "NO"
    },
    {
        "name": "Oman",
        "dial_code": "+968",
        "code": "OM"
    },
    {
        "name": "Pakistan",
        "dial_code": "+92",
        "code": "PK"
    },
    {
        "name": "Palau",
        "dial_code": "+680",
        "code": "PW"
    },
    {
        "name": "Palestinian Territory, Occupied",
        "dial_code": "+970",
        "code": "PS"
    },
    {
        "name": "Panama",
        "dial_code": "+507",
        "code": "PA"
    },
    {
        "name": "Papua New Guinea",
        "dial_code": "+675",
        "code": "PG"
    },
    {
        "name": "Paraguay",
        "dial_code": "+595",
        "code": "PY"
    },
    {
        "name": "Peru",
        "dial_code": "+51",
        "code": "PE"
    },
    {
        "name": "Philippines",
        "dial_code": "+63",
        "code": "PH"
    },
    {
        "name": "Pitcairn",
        "dial_code": "+872",
        "code": "PN"
    },
    {
        "name": "Poland",
        "dial_code": "+48",
        "code": "PL"
    },
    {
        "name": "Portugal",
        "dial_code": "+351",
        "code": "PT"
    },
    {
        "name": "Puerto Rico",
        "dial_code": "+1939",
        "code": "PR"
    },
    {
        "name": "Qatar",
        "dial_code": "+974",
        "code": "QA"
    },
    {
        "name": "Romania",
        "dial_code": "+40",
        "code": "RO"
    },
    {
        "name": "Russia",
        "dial_code": "+7",
        "code": "RU"
    },
    {
        "name": "Rwanda",
        "dial_code": "+250",
        "code": "RW"
    },
    {
        "name": "Reunion",
        "dial_code": "+262",
        "code": "RE"
    },
    {
        "name": "Saint Barthelemy",
        "dial_code": "+590",
        "code": "BL"
    },
    {
        "name": "Saint Helena, Ascension and Tristan Da Cunha",
        "dial_code": "+290",
        "code": "SH"
    },
    {
        "name": "Saint Kitts and Nevis",
        "dial_code": "+1869",
        "code": "KN"
    },
    {
        "name": "Saint Lucia",
        "dial_code": "+1758",
        "code": "LC"
    },
    {
        "name": "Saint Martin",
        "dial_code": "+590",
        "code": "MF"
    },
    {
        "name": "Saint Pierre and Miquelon",
        "dial_code": "+508",
        "code": "PM"
    },
    {
        "name": "Saint Vincent and the Grenadines",
        "dial_code": "+1784",
        "code": "VC"
    },
    {
        "name": "Samoa",
        "dial_code": "+685",
        "code": "WS"
    },
    {
        "name": "San Marino",
        "dial_code": "+378",
        "code": "SM"
    },
    {
        "name": "Sao Tome and Principe",
        "dial_code": "+239",
        "code": "ST"
    },
    {
        "name": "Saudi Arabia",
        "dial_code": "+966",
        "code": "SA"
    },
    {
        "name": "Senegal",
        "dial_code": "+221",
        "code": "SN"
    },
    {
        "name": "Serbia",
        "dial_code": "+381",
        "code": "RS"
    },
    {
        "name": "Seychelles",
        "dial_code": "+248",
        "code": "SC"
    },
    {
        "name": "Sierra Leone",
        "dial_code": "+232",
        "code": "SL"
    },
    {
        "name": "Singapore",
        "dial_code": "+65",
        "code": "SG"
    },
    {
        "name": "Slovakia",
        "dial_code": "+421",
        "code": "SK"
    },
    {
        "name": "Slovenia",
        "dial_code": "+386",
        "code": "SI"
    },
    {
        "name": "Solomon Islands",
        "dial_code": "+677",
        "code": "SB"
    },
    {
        "name": "Somalia",
        "dial_code": "+252",
        "code": "SO"
    },
    {
        "name": "South Africa",
        "dial_code": "+27",
        "code": "ZA"
    },
    {
        "name": "South Sudan",
        "dial_code": "+211",
        "code": "SS"
    },
    {
        "name": "South Georgia and the South Sandwich Islands",
        "dial_code": "+500",
        "code": "GS"
    },
    {
        "name": "Spain",
        "dial_code": "+34",
        "code": "ES"
    },
    {
        "name": "Sri Lanka",
        "dial_code": "+94",
        "code": "LK"
    },
    {
        "name": "Sudan",
        "dial_code": "+249",
        "code": "SD"
    },
    {
        "name": "Suriname",
        "dial_code": "+597",
        "code": "SR"
    },
    {
        "name": "Svalbard and Jan Mayen",
        "dial_code": "+47",
        "code": "SJ"
    },
    {
        "name": "Swaziland",
        "dial_code": "+268",
        "code": "SZ"
    },
    {
        "name": "Sweden",
        "dial_code": "+46",
        "code": "SE"
    },
    {
        "name": "Switzerland",
        "dial_code": "+41",
        "code": "CH"
    },
    {
        "name": "Syrian Arab Republic",
        "dial_code": "+963",
        "code": "SY"
    },
    {
        "name": "Taiwan",
        "dial_code": "+886",
        "code": "TW"
    },
    {
        "name": "Tajikistan",
        "dial_code": "+992",
        "code": "TJ"
    },
    {
        "name": "Tanzania, United Republic of Tanzania",
        "dial_code": "+255",
        "code": "TZ"
    },
    {
        "name": "Thailand",
        "dial_code": "+66",
        "code": "TH"
    },
    {
        "name": "Timor-Leste",
        "dial_code": "+670",
        "code": "TL"
    },
    {
        "name": "Togo",
        "dial_code": "+228",
        "code": "TG"
    },
    {
        "name": "Tokelau",
        "dial_code": "+690",
        "code": "TK"
    },
    {
        "name": "Tonga",
        "dial_code": "+676",
        "code": "TO"
    },
    {
        "name": "Trinidad and Tobago",
        "dial_code": "+1868",
        "code": "TT"
    },
    {
        "name": "Tunisia",
        "dial_code": "+216",
        "code": "TN"
    },
    {
        "name": "Turkey",
        "dial_code": "+90",
        "code": "TR"
    },
    {
        "name": "Turkmenistan",
        "dial_code": "+993",
        "code": "TM"
    },
    {
        "name": "Turks and Caicos Islands",
        "dial_code": "+1649",
        "code": "TC"
    },
    {
        "name": "Tuvalu",
        "dial_code": "+688",
        "code": "TV"
    },
    {
        "name": "Uganda",
        "dial_code": "+256",
        "code": "UG"
    },
    {
        "name": "Ukraine",
        "dial_code": "+380",
        "code": "UA"
    },
    {
        "name": "United Arab Emirates",
        "dial_code": "+971",
        "code": "AE"
    },
    {
        "name": "United Kingdom",
        "dial_code": "+44",
        "code": "GB"
    },
    {
        "name": "United States",
        "dial_code": "+1",
        "code": "US"
    },
    {
        "name": "Uruguay",
        "dial_code": "+598",
        "code": "UY"
    },
    {
        "name": "Uzbekistan",
        "dial_code": "+998",
        "code": "UZ"
    },
    {
        "name": "Vanuatu",
        "dial_code": "+678",
        "code": "VU"
    },
    {
        "name": "Venezuela, Bolivarian Republic of Venezuela",
        "dial_code": "+58",
        "code": "VE"
    },
    {
        "name": "Vietnam",
        "dial_code": "+84",
        "code": "VN"
    },
    {
        "name": "Virgin Islands, British",
        "dial_code": "+1284",
        "code": "VG"
    },
    {
        "name": "Virgin Islands, U.S.",
        "dial_code": "+1340",
        "code": "VI"
    },
    {
        "name": "Wallis and Futuna",
        "dial_code": "+681",
        "code": "WF"
    },
    {
        "name": "Yemen",
        "dial_code": "+967",
        "code": "YE"
    },
    {
        "name": "Zambia",
        "dial_code": "+260",
        "code": "ZM"
    },
    {
        "name": "Zimbabwe",
        "dial_code": "+263",
        "code": "ZW"
    }
]
export const isRTL = (lang: string) => RTLlanguages.includes(lang)
export const defaultLanguage = "en";
export const AUDIO_RECORDING_MAX_LIMIT = 90; // 1.5 minutes
export const RTLlanguages = [
    'ae',	/* Avestan */
    'ar',   /* 'العربية', Arabic */
    'arc',  /* Aramaic */
    'bcc',  /* 'بلوچی مکرانی', Southern Balochi */
    'bqi',  /* 'بختياري', Bakthiari */
    'ckb',  /* 'Soranî / کوردی', Sorani */
    'dv',   /* Dhivehi */
    'fa',   /* 'فارسی', Persian */
    'glk',  /* 'گیلکی', Gilaki */
    'he',   /* 'עברית', Hebrew */
    'iw',   /* 'עברית', Hebrew */
    'ku',   /* 'Kurdî / كوردی', Kurdish */
    'mzn',  /* 'مازِرونی', Mazanderani */
    'nqo',  /* N'Ko */
    'pnb',  /* 'پنجابی', Western Punjabi */
    'ps',   /* 'پښتو', Pashto, */
    'sd',   /* 'سنڌي', Sindhi */
    'ug',   /* 'Uyghurche / ئۇيغۇرچە', Uyghur */
    'ur',    /* 'اردو', Urdu */
    'yi'    /* 'ייִדיש', Yiddish */
];

export const ListOfAllLanguages = {
    "ab": {
        "name": "Abkhaz",
        "nativeName": "аҧсуа"
    },
    "aa": {
        "name": "Afar",
        "nativeName": "Afaraf"
    },
    "af": {
        "name": "Afrikaans",
        "nativeName": "Afrikaans"
    },
    "ak": {
        "name": "Akan",
        "nativeName": "Akan"
    },
    "sq": {
        "name": "Albanian",
        "nativeName": "Shqip"
    },
    "am": {
        "name": "Amharic",
        "nativeName": "አማርኛ"
    },
    "ar": {
        "name": "Arabic",
        "nativeName": "العربية"
    },
    "an": {
        "name": "Aragonese",
        "nativeName": "Aragonés"
    },
    "hy": {
        "name": "Armenian",
        "nativeName": "Հայերեն"
    },
    "as": {
        "name": "Assamese",
        "nativeName": "অসমীয়া"
    },
    "av": {
        "name": "Avaric",
        "nativeName": "авар мацӀ, магӀарул мацӀ"
    },
    "ae": {
        "name": "Avestan",
        "nativeName": "avesta"
    },
    "ay": {
        "name": "Aymara",
        "nativeName": "aymar aru"
    },
    "az": {
        "name": "Azerbaijani",
        "nativeName": "azərbaycan dili"
    },
    "bm": {
        "name": "Bambara",
        "nativeName": "bamanankan"
    },
    "ba": {
        "name": "Bashkir",
        "nativeName": "башҡорт теле"
    },
    "eu": {
        "name": "Basque",
        "nativeName": "euskara, euskera"
    },
    "be": {
        "name": "Belarusian",
        "nativeName": "Беларуская"
    },
    "bn": {
        "name": "Bengali",
        "nativeName": "বাংলা"
    },
    "bh": {
        "name": "Bihari",
        "nativeName": "भोजपुरी"
    },
    "bi": {
        "name": "Bislama",
        "nativeName": "Bislama"
    },
    "bs": {
        "name": "Bosnian",
        "nativeName": "bosanski jezik"
    },
    "br": {
        "name": "Breton",
        "nativeName": "brezhoneg"
    },
    "bg": {
        "name": "Bulgarian",
        "nativeName": "български език"
    },
    "my": {
        "name": "Burmese",
        "nativeName": "ဗမာစာ"
    },
    "ca": {
        "name": "Catalan; Valencian",
        "nativeName": "Català"
    },
    "ch": {
        "name": "Chamorro",
        "nativeName": "Chamoru"
    },
    "ce": {
        "name": "Chechen",
        "nativeName": "нохчийн мотт"
    },
    "ny": {
        "name": "Chichewa; Chewa; Nyanja",
        "nativeName": "chiCheŵa, chinyanja"
    },
    "zh": {
        "name": "Chinese",
        "nativeName": "中文 (Zhōngwén), 汉语, 漢語"
    },
    "cv": {
        "name": "Chuvash",
        "nativeName": "чӑваш чӗлхи"
    },
    "kw": {
        "name": "Cornish",
        "nativeName": "Kernewek"
    },
    "co": {
        "name": "Corsican",
        "nativeName": "corsu, lingua corsa"
    },
    "cr": {
        "name": "Cree",
        "nativeName": "ᓀᐦᐃᔭᐍᐏᐣ"
    },
    "hr": {
        "name": "Croatian",
        "nativeName": "hrvatski"
    },
    "cs": {
        "name": "Czech",
        "nativeName": "česky, čeština"
    },
    "da": {
        "name": "Danish",
        "nativeName": "dansk"
    },
    "dv": {
        "name": "Divehi; Dhivehi; Maldivian;",
        "nativeName": "ދިވެހި"
    },
    "nl": {
        "name": "Dutch",
        "nativeName": "Nederlands, Vlaams"
    },
    "en": {
        "name": "English",
        "nativeName": "English"
    },
    "eo": {
        "name": "Esperanto",
        "nativeName": "Esperanto"
    },
    "et": {
        "name": "Estonian",
        "nativeName": "eesti, eesti keel"
    },
    "ee": {
        "name": "Ewe",
        "nativeName": "Eʋegbe"
    },
    "fo": {
        "name": "Faroese",
        "nativeName": "føroyskt"
    },
    "fj": {
        "name": "Fijian",
        "nativeName": "vosa Vakaviti"
    },
    "fi": {
        "name": "Finnish",
        "nativeName": "suomi, suomen kieli"
    },
    "fr": {
        "name": "French",
        "nativeName": "français, langue française"
    },
    "ff": {
        "name": "Fula; Fulah; Pulaar; Pular",
        "nativeName": "Fulfulde, Pulaar, Pular"
    },
    "gl": {
        "name": "Galician",
        "nativeName": "Galego"
    },
    "ka": {
        "name": "Georgian",
        "nativeName": "ქართული"
    },
    "de": {
        "name": "German",
        "nativeName": "Deutsch"
    },
    "el": {
        "name": "Greek, Modern",
        "nativeName": "Ελληνικά"
    },
    "gn": {
        "name": "Guaraní",
        "nativeName": "Avañeẽ"
    },
    "gu": {
        "name": "Gujarati",
        "nativeName": "ગુજરાતી"
    },
    "ht": {
        "name": "Haitian; Haitian Creole",
        "nativeName": "Kreyòl ayisyen"
    },
    "ha": {
        "name": "Hausa",
        "nativeName": "Hausa, هَوُسَ"
    },
    "he": {
        "name": "Hebrew",
        "nativeName": "עברית"
    },
    "iw": {
        "name": "Hebrew",
        "nativeName": "עברית"
    },
    "hz": {
        "name": "Herero",
        "nativeName": "Otjiherero"
    },
    "hi": {
        "name": "Hindi",
        "nativeName": "हिन्दी, हिंदी"
    },
    "ho": {
        "name": "Hiri Motu",
        "nativeName": "Hiri Motu"
    },
    "hu": {
        "name": "Hungarian",
        "nativeName": "Magyar"
    },
    "ia": {
        "name": "Interlingua",
        "nativeName": "Interlingua"
    },
    "id": {
        "name": "Indonesian",
        "nativeName": "Bahasa Indonesia"
    },
    "ie": {
        "name": "Interlingue",
        "nativeName": "Originally called Occidental; then Interlingue after WWII"
    },
    "ga": {
        "name": "Irish",
        "nativeName": "Gaeilge"
    },
    "ig": {
        "name": "Igbo",
        "nativeName": "Asụsụ Igbo"
    },
    "ik": {
        "name": "Inupiaq",
        "nativeName": "Iñupiaq, Iñupiatun"
    },
    "io": {
        "name": "Ido",
        "nativeName": "Ido"
    },
    "is": {
        "name": "Icelandic",
        "nativeName": "Íslenska"
    },
    "it": {
        "name": "Italian",
        "nativeName": "Italiano"
    },
    "iu": {
        "name": "Inuktitut",
        "nativeName": "ᐃᓄᒃᑎᑐᑦ"
    },
    "ja": {
        "name": "Japanese",
        "nativeName": "日本語 (にほんご／にっぽんご)"
    },
    "jv": {
        "name": "Javanese",
        "nativeName": "basa Jawa"
    },
    "kl": {
        "name": "Kalaallisut, Greenlandic",
        "nativeName": "kalaallisut, kalaallit oqaasii"
    },
    "kn": {
        "name": "Kannada",
        "nativeName": "ಕನ್ನಡ"
    },
    "kr": {
        "name": "Kanuri",
        "nativeName": "Kanuri"
    },
    "ks": {
        "name": "Kashmiri",
        "nativeName": "कश्मीरी, كشميري‎"
    },
    "kk": {
        "name": "Kazakh",
        "nativeName": "Қазақ тілі"
    },
    "km": {
        "name": "Khmer",
        "nativeName": "ភាសាខ្មែរ"
    },
    "ki": {
        "name": "Kikuyu, Gikuyu",
        "nativeName": "Gĩkũyũ"
    },
    "rw": {
        "name": "Kinyarwanda",
        "nativeName": "Ikinyarwanda"
    },
    "ky": {
        "name": "Kirghiz, Kyrgyz",
        "nativeName": "кыргыз тили"
    },
    "kv": {
        "name": "Komi",
        "nativeName": "коми кыв"
    },
    "kg": {
        "name": "Kongo",
        "nativeName": "KiKongo"
    },
    "ko": {
        "name": "Korean",
        "nativeName": "한국어 (韓國語), 조선말 (朝鮮語)"
    },
    "ku": {
        "name": "Kurdish",
        "nativeName": "Kurdî, كوردی‎"
    },
    "kj": {
        "name": "Kwanyama, Kuanyama",
        "nativeName": "Kuanyama"
    },
    "la": {
        "name": "Latin",
        "nativeName": "latine, lingua latina"
    },
    "lb": {
        "name": "Luxembourgish, Letzeburgesch",
        "nativeName": "Lëtzebuergesch"
    },
    "lg": {
        "name": "Luganda",
        "nativeName": "Luganda"
    },
    "li": {
        "name": "Limburgish, Limburgan, Limburger",
        "nativeName": "Limburgs"
    },
    "ln": {
        "name": "Lingala",
        "nativeName": "Lingála"
    },
    "lo": {
        "name": "Lao",
        "nativeName": "ພາສາລາວ"
    },
    "lt": {
        "name": "Lithuanian",
        "nativeName": "lietuvių kalba"
    },
    "lu": {
        "name": "Luba-Katanga",
        "nativeName": ""
    },
    "lv": {
        "name": "Latvian",
        "nativeName": "latviešu valoda"
    },
    "gv": {
        "name": "Manx",
        "nativeName": "Gaelg, Gailck"
    },
    "mk": {
        "name": "Macedonian",
        "nativeName": "македонски јазик"
    },
    "mg": {
        "name": "Malagasy",
        "nativeName": "Malagasy fiteny"
    },
    "ms": {
        "name": "Malay",
        "nativeName": "bahasa Melayu, بهاس ملايو‎"
    },
    "ml": {
        "name": "Malayalam",
        "nativeName": "മലയാളം"
    },
    "mt": {
        "name": "Maltese",
        "nativeName": "Malti"
    },
    "mi": {
        "name": "Māori",
        "nativeName": "te reo Māori"
    },
    "mr": {
        "name": "Marathi (Marāṭhī)",
        "nativeName": "मराठी"
    },
    "mh": {
        "name": "Marshallese",
        "nativeName": "Kajin M̧ajeļ"
    },
    "mn": {
        "name": "Mongolian",
        "nativeName": "монгол"
    },
    "na": {
        "name": "Nauru",
        "nativeName": "Ekakairũ Naoero"
    },
    "nv": {
        "name": "Navajo, Navaho",
        "nativeName": "Diné bizaad, Dinékʼehǰí"
    },
    "nb": {
        "name": "Norwegian Bokmål",
        "nativeName": "Norsk bokmål"
    },
    "nd": {
        "name": "North Ndebele",
        "nativeName": "isiNdebele"
    },
    "ne": {
        "name": "Nepali",
        "nativeName": "नेपाली"
    },
    "ng": {
        "name": "Ndonga",
        "nativeName": "Owambo"
    },
    "nn": {
        "name": "Norwegian Nynorsk",
        "nativeName": "Norsk nynorsk"
    },
    "no": {
        "name": "Norwegian",
        "nativeName": "Norsk"
    },
    "ii": {
        "name": "Nuosu",
        "nativeName": "ꆈꌠ꒿ Nuosuhxop"
    },
    "nr": {
        "name": "South Ndebele",
        "nativeName": "isiNdebele"
    },
    "oc": {
        "name": "Occitan",
        "nativeName": "Occitan"
    },
    "oj": {
        "name": "Ojibwe, Ojibwa",
        "nativeName": "ᐊᓂᔑᓈᐯᒧᐎᓐ"
    },
    "cu": {
        "name": "Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic",
        "nativeName": "ѩзыкъ словѣньскъ"
    },
    "om": {
        "name": "Oromo",
        "nativeName": "Afaan Oromoo"
    },
    "or": {
        "name": "Oriya",
        "nativeName": "ଓଡ଼ିଆ"
    },
    "os": {
        "name": "Ossetian, Ossetic",
        "nativeName": "ирон æвзаг"
    },
    "pa": {
        "name": "Panjabi, Punjabi",
        "nativeName": "ਪੰਜਾਬੀ, پنجابی‎"
    },
    "pi": {
        "name": "Pāli",
        "nativeName": "पाऴि"
    },
    "fa": {
        "name": "Persian",
        "nativeName": "فارسی"
    },
    "pl": {
        "name": "Polish",
        "nativeName": "polski"
    },
    "ps": {
        "name": "Pashto, Pushto",
        "nativeName": "پښتو"
    },
    "pt": {
        "name": "Portuguese",
        "nativeName": "Português"
    },
    "qu": {
        "name": "Quechua",
        "nativeName": "Runa Simi, Kichwa"
    },
    "rm": {
        "name": "Romansh",
        "nativeName": "rumantsch grischun"
    },
    "rn": {
        "name": "Kirundi",
        "nativeName": "kiRundi"
    },
    "ro": {
        "name": "Romanian, Moldavian, Moldovan",
        "nativeName": "română"
    },
    "ru": {
        "name": "Russian",
        "nativeName": "русский язык"
    },
    "sa": {
        "name": "Sanskrit (Saṁskṛta)",
        "nativeName": "संस्कृतम्"
    },
    "sc": {
        "name": "Sardinian",
        "nativeName": "sardu"
    },
    "sd": {
        "name": "Sindhi",
        "nativeName": "सिन्धी, سنڌي، سندھی‎"
    },
    "se": {
        "name": "Northern Sami",
        "nativeName": "Davvisámegiella"
    },
    "sm": {
        "name": "Samoan",
        "nativeName": "gagana faa Samoa"
    },
    "sg": {
        "name": "Sango",
        "nativeName": "yângâ tî sängö"
    },
    "sr": {
        "name": "Serbian",
        "nativeName": "српски језик"
    },
    "gd": {
        "name": "Scottish Gaelic; Gaelic",
        "nativeName": "Gàidhlig"
    },
    "sn": {
        "name": "Shona",
        "nativeName": "chiShona"
    },
    "si": {
        "name": "Sinhala, Sinhalese",
        "nativeName": "සිංහල"
    },
    "sk": {
        "name": "Slovak",
        "nativeName": "slovenčina"
    },
    "sl": {
        "name": "Slovene",
        "nativeName": "slovenščina"
    },
    "so": {
        "name": "Somali",
        "nativeName": "Soomaaliga, af Soomaali"
    },
    "st": {
        "name": "Southern Sotho",
        "nativeName": "Sesotho"
    },
    "es": {
        "name": "Spanish; Castilian",
        "nativeName": "español, castellano"
    },
    "su": {
        "name": "Sundanese",
        "nativeName": "Basa Sunda"
    },
    "sw": {
        "name": "Swahili",
        "nativeName": "Kiswahili"
    },
    "ss": {
        "name": "Swati",
        "nativeName": "SiSwati"
    },
    "sv": {
        "name": "Swedish",
        "nativeName": "svenska"
    },
    "ta": {
        "name": "Tamil",
        "nativeName": "தமிழ்"
    },
    "te": {
        "name": "Telugu",
        "nativeName": "తెలుగు"
    },
    "tg": {
        "name": "Tajik",
        "nativeName": "тоҷикӣ, toğikī, تاجیکی‎"
    },
    "th": {
        "name": "Thai",
        "nativeName": "ไทย"
    },
    "ti": {
        "name": "Tigrinya",
        "nativeName": "ትግርኛ"
    },
    "bo": {
        "name": "Tibetan Standard, Tibetan, Central",
        "nativeName": "བོད་ཡིག"
    },
    "tk": {
        "name": "Turkmen",
        "nativeName": "Türkmen, Түркмен"
    },
    "tl": {
        "name": "Tagalog",
        "nativeName": "Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔"
    },
    "tn": {
        "name": "Tswana",
        "nativeName": "Setswana"
    },
    "to": {
        "name": "Tonga (Tonga Islands)",
        "nativeName": "faka Tonga"
    },
    "tr": {
        "name": "Turkish",
        "nativeName": "Türkçe"
    },
    "ts": {
        "name": "Tsonga",
        "nativeName": "Xitsonga"
    },
    "tt": {
        "name": "Tatar",
        "nativeName": "татарча, tatarça, تاتارچا‎"
    },
    "tw": {
        "name": "Twi",
        "nativeName": "Twi"
    },
    "ty": {
        "name": "Tahitian",
        "nativeName": "Reo Tahiti"
    },
    "ug": {
        "name": "Uighur, Uyghur",
        "nativeName": "Uyƣurqə, ئۇيغۇرچە‎"
    },
    "uk": {
        "name": "Ukrainian",
        "nativeName": "українська"
    },
    "ur": {
        "name": "Urdu",
        "nativeName": "اردو"
    },
    "uz": {
        "name": "Uzbek",
        "nativeName": "zbek, Ўзбек, أۇزبېك‎"
    },
    "ve": {
        "name": "Venda",
        "nativeName": "Tshivenḓa"
    },
    "vi": {
        "name": "Vietnamese",
        "nativeName": "Tiếng Việt"
    },
    "vo": {
        "name": "Volapük",
        "nativeName": "Volapük"
    },
    "wa": {
        "name": "Walloon",
        "nativeName": "Walon"
    },
    "cy": {
        "name": "Welsh",
        "nativeName": "Cymraeg"
    },
    "wo": {
        "name": "Wolof",
        "nativeName": "Wollof"
    },
    "fy": {
        "name": "Western Frisian",
        "nativeName": "Frysk"
    },
    "xh": {
        "name": "Xhosa",
        "nativeName": "isiXhosa"
    },
    "yi": {
        "name": "Yiddish",
        "nativeName": "ייִדיש"
    },
    "yo": {
        "name": "Yoruba",
        "nativeName": "Yorùbá"
    },
    "za": {
        "name": "Zhuang, Chuang",
        "nativeName": "Saɯ cueŋƅ, Saw cuengh"
    }
}


export const sampleSessionName = 'Brain Buster';
export const sampleQuestions = [{
    "id": "bdd7bc11-6e40-46a1-8794-2dc6da44eace",
    "kind": "MCQ",
    "state": "DRAFT",
    "text": "What is the capital of France?",
    "options": [{
        "text": "A_Paris"
    }, {
        "text": "B_Rome"
    }, {
        "text": "C_London"
    }, {
        "text": "D_Berlin"
    }],
    "correct_answer": {
        "text": "A_Paris"
    }
}, {
    "id": "e80d9b02-25eb-49c5-b0b7-3cb9d22311fc",
    "kind": "MCQ",
    "state": "DRAFT",
    "text": "What is the capital city of Australia?",
    "options": [{
        "text": "A_Sydney"
    }, {
        "text": "B_Canberra"
    }, {
        "text": "C_Melbourne"
    }, {
        "text": "D_Brisbane"
    }],
    "correct_answer": {
        "text": "B_Canberra"
    }
}, {
    "id": "fb508ea7-611e-4421-9cb2-f99516879d16",
    "kind": "MCQ",
    "state": "DRAFT",
    "text": "What is the name of this famous painting by Leonardo da Vinci?",
    "images": [{
        "url": "3e4c4188-2b8d-49ba-80bf-824019fb780b"
    }],
    "options": [{
        "text": "A_The Last Supper"
    }, {
        "text": "B_The Birth of Venus"
    }, {
        "text": "C_Mona Lisa"
    }, {
        "text": "D_The Persistence of Memory"
    }],
    "correct_answer": {
        "text": "C_Mona Lisa"
    }
}, {
    "id": "26510e23-016d-4012-a520-753868fe92d3",
    "kind": "TEXT",
    "state": "DRAFT",
    "text": "What is the fifth planet from the Sun?",
    "options": [{
        "text": "Jupiter"
    }],
    "correct_answer": {
        "text": "Jupiter"
    }
}, {
    "id": "7ca2165a-b114-4ce9-b7f3-a76a50ef0748",
    "kind": "MCQ",
    "state": "DRAFT",
    "text": "What is the name of the villain in the movie 'The Lion King'?",
    "options": [{
        "text": "A_Zira"
    }, {
        "text": "B_Scar"
    }, {
        "text": "C_Kovu"
    }, {
        "text": "D_Rafiki"
    }],
    "correct_answer": {
        "text": "B_Scar"
    }
}, {
    "id": "b8459097-1a63-4544-8747-8b3c8571a3c0",
    "kind": "MCQ",
    "state": "DRAFT",
    "text": "What is the formula for calculating the area of a circle?",
    "images": [{
        "url": "23260270-08d7-4a1e-bdcb-55eaa5cd4643"
    }],
    "options": [{
        "text": "A_πr^2"
    }, {
        "text": "B_πd^2"
    }, {
        "text": "C_2πr"
    }, {
        "text": "D_2πd"
    }],
    "correct_answer": {
        "text": "A_πr^2"
    }
}, {
    "id": "0f23a6ca-fe71-43cd-8ba2-f6e3ecfe1e59",
    "kind": "MCQ",
    "state": "DRAFT",
    "text": "What is the chemical symbol for the element iron?",
    "images": [{
        "url": "ca8d8588-611c-4d06-b010-46c7fc154da6"
    }],
    "options": [{
        "text": "A_Fr"
    }, {
        "text": "B_Ir"
    }, {
        "text": "C_Fe"
    }, {
        "text": "D_Irn"
    }],
    "correct_answer": {
        "text": "C_Fe"
    }
}, {
    "id": "85c568ad-4a22-4071-85cf-81805a5969f4",
    "kind": "MCQ",
    "state": "DRAFT",
    "text": "What is the name of this famous fictional character created by J.K. Rowling?",
    "images": [{
        "url": "be74d04e-72e2-4de4-b1ea-2c8a704bcdd8"
    }],
    "options": [{
        "text": "A_Harry Potter"
    }, {
        "text": "B_Severus Snape"
    }, {
        "text": "C_Ron Weasley"
    }, {
        "text": "D_Albus Dumbledore"
    }],
    "correct_answer": {
        "text": "B_Severus Snape"
    }
},
{
    "id": "bdd7bc11-6e40-46a1-8794-2dc6da44eac2",
    "kind": "MCQ",
    "state": "DRAFT",
    "text": "The first iPhone was released in 2005.",
    "options": [{
        "text": "A_True"
    }, {
        "text": "B_False"
    }, {
        "text": "C_"
    }, {
        "text": "D_"
    }],
    "correct_answer": {
        "text": "B_False"
    }
},
{
    "id": "26510e23-016d-4012-a520-753868fe92da",
    "kind": "TEXT",
    "state": "DRAFT",
    "text": "How many planets are there in our solar system?",
    "options": [{
        "text": "8"
    }],
    "correct_answer": {
        "text": "8"
    }
}
]

export const sampleQuestionLibrary: QuestionLibrary = {
    created_by: "botfather@vidya.us",
    subject: "General Awareness",
    created_on: new Date(),
    id: "",
    is_public: false,
    name: "Brain Busters",
    shared_with_institute: [],
    shared_with_user: [],
    updated_by: "",
    updated_on: new Date(),
    brief: "",
    image: "",
    questions: [],
    tags: ["ice breaker", "easy"]
}
